export default "__VITE_ASSET__oaGQLsat__"